// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"54bcf9cb","164":"bb05e751","254":"4e50b6f5","301":"2255eb2a","444":"e175b296","453":"2fbce547"}[chunkId] + ".chunk.js";
};